export enum MenuItemType {
    Camera = 'camera',
    Devices = 'devices',
    Microphone = 'mic',
    Speaker = 'speaker',
}
